//% Observe all transition elements
observe_all();

//# Function that observe all elements with the transition class
function observe_all() {
  //% Target all elements with the 'transistion' class
  const elements = document.querySelectorAll(".transition");

  //% Exit function if no elements are found on page
  if (!elements) {
    console.log("No transition elements found");
    return;
  }

  //# Helper function - Invert the positive/negative value of the data property to avoid using negative values in dataset
  function invertNegative(input_string) {
    return input_string.includes("-")
      ? input_string.replace("-", "")
      : "-" + input_string;
  }

  //% Create observer for each transition element
  elements.forEach((el) => {
    //) Valid data attributes
    //* data-start
    //* data-end
    //* data-intersection
    //* data-speed
    //* data-transition
    //* data-repeat
    //* data-trigger-class
    //* data-callback

    //@ Set variables
    //$ Set trigger start point if defined in attribute else use default of 0% which is bottom of screen
    let trigger_start = el.dataset.start
      ? invertNegative(el.dataset.start)
      : // ? el.dataset.start
        "0%";

    //$ Set trigger end point if defined in attribute else use default of 0% which is top of screen
    const trigger_end = el.dataset.end ? invertNegative(el.dataset.end) : "0%";

    //$ Set intersection_point if defined in data attribute else use default of 0 which is top point of element, 1 bottom of element
    const intersection_point = el.dataset.intersection
      ? parseFloat(el.dataset.intersection)
      : 0;

    //$ If speed atrribute exist set it otherwise make it null
    const speed = el.dataset.speed ? el.dataset.speed : null;

    //$ If transition atrribute exist set it otherwise make it null
    const transition = el.dataset.transition ? el.dataset.transition : null;

    //$ If element has a data-repeat attribute, set repeat to false else true
    const repeat = el.dataset.hasOwnProperty("repeat") ? true : false;

    //$ If element has a data-trigger-class attribute, set trigger_class to that else default to 'show'
    const trigger_class = el.dataset.triggerClass
      ? el.dataset.triggerClass
      : "show";

    //$ If element has a data-callback attribute, set callback function
    const callback = el.dataset.callback ? el.dataset.callback : null;
    // const callback = el.dataset.callback;

    //@ Use variables
    //$ Set element speed only if it was set in data attribute
    if (speed) {
      el.style.transition = `all ${speed} ease-in-out`;
    }

    //$ Set element transition if it was set in data attribute
    if (transition) {
      el.style.transition = transition;
    }

    //^ Create intersection observer
    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          //$ Add trigger class to elements while intersecting and remove if not
          entry.target.classList.toggle(trigger_class, entry.isIntersecting);

          //$ Check if callback function exist and run if it does and has intersected
          if (
            entry.isIntersecting &&
            callback &&
            typeof window[callback] === "function"
          ) {
            // run callback function
            window[callback]();
          }

          //$ Disconnect observer once triggered (should be default to avoid slow pages)
          if (!repeat && entry.isIntersecting) {
            // observer.unobserve(entry.target);
            observer.disconnect();
            observer = null;
          }
        });
      },
      {
        root: null,
        rootMargin: `${trigger_end} 0px ${trigger_start} 0px`,
        threshold: intersection_point,
      }
    );

    //^ Observe element
    observer.observe(el);
  });
}

//# Function that observe a specified element based on selector
function observe_element(
  target_selector,
  repeat = false,
  trigger_start = "0%",
  trigger_end = "0%",
  intersection_point = 0, //0 start, 1 end
  speed = null,
  trigger_class = "show",
  callback = null
) {
  let trigger_elements;

  //% Check if trigger element argument is a html element
  if (target_selector instanceof HTMLElement) {
    console.log("predefined dom element");
  } else {
    trigger_elements = document.querySelectorAll(target_selector);
  }

  // const trigger_elements = document.querySelectorAll(target_selector);
  if (!trigger_elements) {
    return;
  }

  //% Observer options
  const options = {
    //? The element that is used as the viewport for checking visibility of the target. root = document element
    root: null,

    //? Margin around the root. Sets the intersection point on root element.
    //? top right bottom left
    rootMargin: `${invertNegative(trigger_end)} 0px ${invertNegative(
      trigger_start
    )} 0px`,

    //? How much of the element needs to come into view 0 = edge, 1 = full element
    threshold: intersection_point,
  };

  
  //% Create new intersection observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      //$ Add trigger class to elements when intersecting and remove if not
      entry.target.classList.toggle(trigger_class, entry.isIntersecting);

      //$ Unobserve element once triggered
      if (!repeat && entry.isIntersecting) {
        observer.unobserve(entry.target);
      }
    });
  }, options);

  //% Loop through elements and link to observer
  trigger_elements.forEach((el) => {
    //$ Observe element
    observer.observe(el);

    //$ Add custom transition speed if it was specified
    if (speed) {
      el.style.transition = `all ${speed} ease-in-out`;
    }
  });

  //# Helper function - Invert the positive/negative value of the data property to avoid using negative values in dataset
  function invertNegative(input_string) {
    return input_string.includes("-")
      ? input_string.replace("-", "")
      : "-" + input_string;
  }
}
